import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { TMSCommodity } from 'types/Load';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

type GetCommodityDetailsResponse = {
  commodity: TMSCommodity;
  message: string;
};

export async function getCommodityDetails(
  commodityID: string,
  tmsID: number,
  customerID?: number
): Promise<Result<GetCommodityDetailsResponse, ApiError>> {
  try {
    const params = new URLSearchParams();
    params.append('tmsID', tmsID.toString());
    if (customerID) {
      params.append('customerID', customerID.toString());
    }
    const response = await axios.get<GetCommodityDetailsResponse>(
      `/commodities/${commodityID}/details?${params.toString()}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getCommodityDetails' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get commodity details from TMS' });
    }

    return err({
      message:
        error.response?.data.message ||
        'Failed to get commodity details from TMS',
    });
  }
}
